 
/**
 * Storage Constants
 *
 * Centralized localStorage and sessionStorage key names.
 */

export const STORAGE_KEYS = {
  /** Authentication token for API requests */
  AUTH_TOKEN: 'auth_token',

  /** Currently selected organization ID */
  CURRENT_ORG_ID: 'current_org_id',

  /** User preferences */
  USER_PREFERENCES: 'user_preferences',

  /** Theme preference */
  THEME: 'theme',

  /** Favorite quick entry form IDs */
  QUICK_ENTRY_FAVORITES: 'quick_entry_favorites',

  /** Quick entry account overrides per form */
  QUICK_ENTRY_ACCOUNT_OVERRIDES: 'qe_account_overrides',

  /** Logged-in user's person ID */
  PERSON_ID: 'person_id',

  /** Logged-in user's username */
  USERNAME: 'username',

  /** Logged-in user's entity ID */
  ENTITY_ID: 'entity_id',

  /** Logged-in user's entity name */
  ENTITY_NAME: 'entity_name',

  /** Logged-in user's membership ID */
  MEMBERSHIP_ID: 'membership_id',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

/**
 * Default Organization ID
 * Used as fallback when no organization is selected
 * TODO: Replace with actual organization context from authentication
 */
export const DEFAULT_ORG_ID = '00000000-0000-0000-0000-000000000001';

/**
 * Default Primary Ledger ID
 * Well-known UUID for the PRIMARY ledger to ensure consistency
 * between frontend (localStorage/SQLite) and backend (PostgreSQL)
 */
export const DEFAULT_PRIMARY_LEDGER_ID = '00000000-0000-0000-0000-000000000010';
